
//const server = "https://djamnazi.alwaysdata.net";
const server = "https://djamnazi.fr";

export const MediaUrl = (url)=>{
    if(!!url){
    //const base_url = "https://djamnazi.alwaysdata.net";
    const base_url = "https://djamnazi.fr";
    //const base_url = 'https://localhost:8000';
    return base_url+url.replace('/frontend/','/').replace('.png','.webp').replace('.jpg','.webp').replace('.jpeg','.webp');
    }
    else{return null}
}

export const TranslatedCountrie=(country, t=(country)=>{return country})=>
{
    switch(country)
    {
        case "France":
            return t('produit.france');
        case "Arabie Saoudite":
            return t('produit.saoudite');
        case "Turquie":
            return t('produit.turquie');
        case "Chine":
            return t('produit.chine');
        case "Comores":
            return t('produit.comores');
        default:
            return country
    }
}

export const list_countries = [{'label': 'Afghanistan', 'value': {'name': 'Afghanistan', 'zip': 'AF'}},
    {'label': 'Afrique du Sud', 'value': {'name': 'Afrique du Sud', 'zip': 'ZA'}},
    {'label': 'Albanie', 'value': {'name': 'Albanie', 'zip': 'AL'}},
    {'label': 'Algérie', 'value': {'name': 'Algérie', 'zip': 'DZ'}},
    {'label': 'Allemagne', 'value': {'name': 'Allemagne', 'zip': 'DE'}},
    {'label': 'Andorre', 'value': {'name': 'Andorre', 'zip': 'AD'}},
    {'label': 'Angola', 'value': {'name': 'Angola', 'zip': 'AO'}},
    {'label': 'Anguilla', 'value': {'name': 'Anguilla', 'zip': 'AI'}},
    {'label': 'Antarctique', 'value': {'name': 'Antarctique', 'zip': 'AQ'}},
    {'label': 'Antigua-et-Barbuda',
     'value': {'name': 'Antigua-et-Barbuda', 'zip': 'AG'}},
    {'label': 'Antilles néerlandaises',
     'value': {'name': 'Antilles néerlandaises', 'zip': 'AN'}},
    {'label': 'Arabie saoudite',
     'value': {'name': 'Arabie saoudite', 'zip': 'SA'}},
    {'label': 'Argentine', 'value': {'name': 'Argentine', 'zip': 'AR'}},
    {'label': 'Arménie', 'value': {'name': 'Arménie', 'zip': 'AM'}},
    {'label': 'Aruba', 'value': {'name': 'Aruba', 'zip': 'AW'}},
    {'label': 'Australie', 'value': {'name': 'Australie', 'zip': 'AU'}},
    {'label': 'Autriche', 'value': {'name': 'Autriche', 'zip': 'AT'}},
    {'label': 'Azerbaïdjan', 'value': {'name': 'Azerbaïdjan', 'zip': 'AZ'}},
    {'label': 'Bahamas', 'value': {'name': 'Bahamas', 'zip': 'BS'}},
    {'label': 'Bahreïn', 'value': {'name': 'Bahreïn', 'zip': 'BH'}},
    {'label': 'Bangladesh', 'value': {'name': 'Bangladesh', 'zip': 'BD'}},
    {'label': 'Barbade', 'value': {'name': 'Barbade', 'zip': 'BB'}},
    {'label': 'Bélarus', 'value': {'name': 'Bélarus', 'zip': 'BY'}},
    {'label': 'Belgique', 'value': {'name': 'Belgique', 'zip': 'BE'}},
    {'label': 'Belize', 'value': {'name': 'Belize', 'zip': 'BZ'}},
    {'label': 'Bénin', 'value': {'name': 'Bénin', 'zip': 'BJ'}},
    {'label': 'Bermudes', 'value': {'name': 'Bermudes', 'zip': 'BM'}},
    {'label': 'Bhoutan', 'value': {'name': 'Bhoutan', 'zip': 'BT'}},
    {'label': 'Bolivie', 'value': {'name': 'Bolivie', 'zip': 'BO'}},
    {'label': 'Bosnie-Herzégovine',
     'value': {'name': 'Bosnie-Herzégovine', 'zip': 'BA'}},
    {'label': 'Botswana', 'value': {'name': 'Botswana', 'zip': 'BW'}},
    {'label': 'Brésil', 'value': {'name': 'Brésil', 'zip': 'BR'}},
    {'label': 'Brunéi Darussalam',
     'value': {'name': 'Brunéi Darussalam', 'zip': 'BN'}},
    {'label': 'Bulgarie', 'value': {'name': 'Bulgarie', 'zip': 'BG'}},
    {'label': 'Burkina Faso', 'value': {'name': 'Burkina Faso', 'zip': 'BF'}},
    {'label': 'Burundi', 'value': {'name': 'Burundi', 'zip': 'BI'}},
    {'label': 'Cambodge', 'value': {'name': 'Cambodge', 'zip': 'KH'}},
    {'label': 'Cameroun', 'value': {'name': 'Cameroun', 'zip': 'CM'}},
    {'label': 'Canada', 'value': {'name': 'Canada', 'zip': 'CA'}},
    {'label': 'Cap-Vert', 'value': {'name': 'Cap-Vert', 'zip': 'CV'}},
    {'label': 'Ceuta et Melilla',
     'value': {'name': 'Ceuta et Melilla', 'zip': 'EA'}},
    {'label': 'Chili', 'value': {'name': 'Chili', 'zip': 'CL'}},
    {'label': 'Chine', 'value': {'name': 'Chine', 'zip': 'CN'}},
    {'label': 'Chypre', 'value': {'name': 'Chypre', 'zip': 'CY'}},
    {'label': 'Colombie', 'value': {'name': 'Colombie', 'zip': 'CO'}},
    {'label': 'Comores', 'value': {'name': 'Comores', 'zip': 'KM'}},
    {'label': 'Congo-Brazzaville',
     'value': {'name': 'Congo-Brazzaville', 'zip': 'CG'}},
    {'label': 'Corée du Nord', 'value': {'name': 'Corée du Nord', 'zip': 'KP'}},
    {'label': 'Corée du Sud', 'value': {'name': 'Corée du Sud', 'zip': 'KR'}},
    {'label': 'Costa Rica', 'value': {'name': 'Costa Rica', 'zip': 'CR'}},
    {'label': 'Côte d’Ivoire', 'value': {'name': 'Côte d’Ivoire', 'zip': 'CI'}},
    {'label': 'Croatie', 'value': {'name': 'Croatie', 'zip': 'HR'}},
    {'label': 'Cuba', 'value': {'name': 'Cuba', 'zip': 'CU'}},
    {'label': 'Danemark', 'value': {'name': 'Danemark', 'zip': 'DK'}},
    {'label': 'Diego Garcia', 'value': {'name': 'Diego Garcia', 'zip': 'DG'}},
    {'label': 'Djibouti', 'value': {'name': 'Djibouti', 'zip': 'DJ'}},
    {'label': 'Dominique', 'value': {'name': 'Dominique', 'zip': 'DM'}},
    {'label': 'Égypte', 'value': {'name': 'Égypte', 'zip': 'EG'}},
    {'label': 'El Salvador', 'value': {'name': 'El Salvador', 'zip': 'SV'}},
    {'label': 'Émirats arabes unis',
     'value': {'name': 'Émirats arabes unis', 'zip': 'AE'}},
    {'label': 'Équateur', 'value': {'name': 'Équateur', 'zip': 'EC'}},
    {'label': 'Érythrée', 'value': {'name': 'Érythrée', 'zip': 'ER'}},
    {'label': 'Espagne', 'value': {'name': 'Espagne', 'zip': 'ES'}},
    {'label': 'Estonie', 'value': {'name': 'Estonie', 'zip': 'EE'}},
    {'label': 'État de la Cité du Vatican',
     'value': {'name': 'État de la Cité du Vatican', 'zip': 'VA'}},
    {'label': 'États fédérés de Micronésie',
     'value': {'name': 'États fédérés de Micronésie', 'zip': 'FM'}},
    {'label': 'États-Unis', 'value': {'name': 'États-Unis', 'zip': 'US'}},
    {'label': 'Éthiopie', 'value': {'name': 'Éthiopie', 'zip': 'ET'}},
    {'label': 'Fidji', 'value': {'name': 'Fidji', 'zip': 'FJ'}},
    {'label': 'Finlande', 'value': {'name': 'Finlande', 'zip': 'FI'}},
    {'label': 'France', 'value': {'name': 'France', 'zip': 'FR'}},
    {'label': 'Gabon', 'value': {'name': 'Gabon', 'zip': 'GA'}},
    {'label': 'Gambie', 'value': {'name': 'Gambie', 'zip': 'GM'}},
    {'label': 'Géorgie', 'value': {'name': 'Géorgie', 'zip': 'GE'}},
    {'label': 'Géorgie du Sud et les îles Sandwich du Sud',
     'value': {'name': 'Géorgie du Sud et les îles Sandwich du Sud',
      'zip': 'GS'}},
    {'label': 'Ghana', 'value': {'name': 'Ghana', 'zip': 'GH'}},
    {'label': 'Gibraltar', 'value': {'name': 'Gibraltar', 'zip': 'GI'}},
    {'label': 'Grèce', 'value': {'name': 'Grèce', 'zip': 'GR'}},
    {'label': 'Grenade', 'value': {'name': 'Grenade', 'zip': 'GD'}},
    {'label': 'Groenland', 'value': {'name': 'Groenland', 'zip': 'GL'}},
    {'label': 'Guadeloupe', 'value': {'name': 'Guadeloupe', 'zip': 'GP'}},
    {'label': 'Guam', 'value': {'name': 'Guam', 'zip': 'GU'}},
    {'label': 'Guatemala', 'value': {'name': 'Guatemala', 'zip': 'GT'}},
    {'label': 'Guernesey', 'value': {'name': 'Guernesey', 'zip': 'GG'}},
    {'label': 'Guinée', 'value': {'name': 'Guinée', 'zip': 'GN'}},
    {'label': 'Guinée équatoriale',
     'value': {'name': 'Guinée équatoriale', 'zip': 'GQ'}},
    {'label': 'Guinée-Bissau', 'value': {'name': 'Guinée-Bissau', 'zip': 'GW'}},
    {'label': 'Guyana', 'value': {'name': 'Guyana', 'zip': 'GY'}},
    {'label': 'Guyane française',
     'value': {'name': 'Guyane française', 'zip': 'GF'}},
    {'label': 'Haïti', 'value': {'name': 'Haïti', 'zip': 'HT'}},
    {'label': 'Honduras', 'value': {'name': 'Honduras', 'zip': 'HN'}},
    {'label': 'Hongrie', 'value': {'name': 'Hongrie', 'zip': 'HU'}},
    {'label': 'Île Bouvet', 'value': {'name': 'Île Bouvet', 'zip': 'BV'}},
    {'label': 'Île Christmas', 'value': {'name': 'Île Christmas', 'zip': 'CX'}},
    {'label': 'Île Clipperton', 'value': {'name': 'Île Clipperton', 'zip': 'CP'}},
    {'label': "Île de l'Ascension",
     'value': {'name': "Île de l'Ascension", 'zip': 'AC'}},
    {'label': 'Île de Man', 'value': {'name': 'Île de Man', 'zip': 'IM'}},
    {'label': 'Île Norfolk', 'value': {'name': 'Île Norfolk', 'zip': 'NF'}},
    {'label': 'Îles Åland', 'value': {'name': 'Îles Åland', 'zip': 'AX'}},
    {'label': 'Îles Caïmans', 'value': {'name': 'Îles Caïmans', 'zip': 'KY'}},
    {'label': 'Îles Canaries', 'value': {'name': 'Îles Canaries', 'zip': 'IC'}},
    {'label': 'Îles Cocos - Keeling',
     'value': {'name': 'Îles Cocos - Keeling', 'zip': 'CC'}},
    {'label': 'Îles Cook', 'value': {'name': 'Îles Cook', 'zip': 'CK'}},
    {'label': 'Îles Féroé', 'value': {'name': 'Îles Féroé', 'zip': 'FO'}},
    {'label': 'Îles Heard et MacDonald',
     'value': {'name': 'Îles Heard et MacDonald', 'zip': 'HM'}},
    {'label': 'Îles Malouines', 'value': {'name': 'Îles Malouines', 'zip': 'FK'}},
    {'label': 'Îles Mariannes du Nord',
     'value': {'name': 'Îles Mariannes du Nord', 'zip': 'MP'}},
    {'label': 'Îles Marshall', 'value': {'name': 'Îles Marshall', 'zip': 'MH'}},
    {'label': 'Îles Mineures Éloignées des États-Unis',
     'value': {'name': 'Îles Mineures Éloignées des États-Unis', 'zip': 'UM'}},
    {'label': 'Îles Salomon', 'value': {'name': 'Îles Salomon', 'zip': 'SB'}},
    {'label': 'Îles Turks et Caïques',
     'value': {'name': 'Îles Turks et Caïques', 'zip': 'TC'}},
    {'label': 'Îles Vierges britanniques',
     'value': {'name': 'Îles Vierges britanniques', 'zip': 'VG'}},
    {'label': 'Îles Vierges des États-Unis',
     'value': {'name': 'Îles Vierges des États-Unis', 'zip': 'VI'}},
    {'label': 'Inde', 'value': {'name': 'Inde', 'zip': 'IN'}},
    {'label': 'Indonésie', 'value': {'name': 'Indonésie', 'zip': 'ID'}},
    {'label': 'Irak', 'value': {'name': 'Irak', 'zip': 'IQ'}},
    {'label': 'Iran', 'value': {'name': 'Iran', 'zip': 'IR'}},
    {'label': 'Irlande', 'value': {'name': 'Irlande', 'zip': 'IE'}},
    {'label': 'Islande', 'value': {'name': 'Islande', 'zip': 'IS'}},
    {'label': 'Israël', 'value': {'name': 'Israël', 'zip': 'IL'}},
    {'label': 'Italie', 'value': {'name': 'Italie', 'zip': 'IT'}},
    {'label': 'Jamaïque', 'value': {'name': 'Jamaïque', 'zip': 'JM'}},
    {'label': 'Japon', 'value': {'name': 'Japon', 'zip': 'JP'}},
    {'label': 'Jersey', 'value': {'name': 'Jersey', 'zip': 'JE'}},
    {'label': 'Jordanie', 'value': {'name': 'Jordanie', 'zip': 'JO'}},
    {'label': 'Kazakhstan', 'value': {'name': 'Kazakhstan', 'zip': 'KZ'}},
    {'label': 'Kenya', 'value': {'name': 'Kenya', 'zip': 'KE'}},
    {'label': 'Kirghizistan', 'value': {'name': 'Kirghizistan', 'zip': 'KG'}},
    {'label': 'Kiribati', 'value': {'name': 'Kiribati', 'zip': 'KI'}},
    {'label': 'Koweït', 'value': {'name': 'Koweït', 'zip': 'KW'}},
    {'label': 'Laos', 'value': {'name': 'Laos', 'zip': 'LA'}},
    {'label': 'Lesotho', 'value': {'name': 'Lesotho', 'zip': 'LS'}},
    {'label': 'Lettonie', 'value': {'name': 'Lettonie', 'zip': 'LV'}},
    {'label': 'Liban', 'value': {'name': 'Liban', 'zip': 'LB'}},
    {'label': 'Libéria', 'value': {'name': 'Libéria', 'zip': 'LR'}},
    {'label': 'Libye', 'value': {'name': 'Libye', 'zip': 'LY'}},
    {'label': 'Liechtenstein', 'value': {'name': 'Liechtenstein', 'zip': 'LI'}},
    {'label': 'Lituanie', 'value': {'name': 'Lituanie', 'zip': 'LT'}},
    {'label': 'Luxembourg', 'value': {'name': 'Luxembourg', 'zip': 'LU'}},
    {'label': 'Macédoine', 'value': {'name': 'Macédoine', 'zip': 'MK'}},
    {'label': 'Madagascar', 'value': {'name': 'Madagascar', 'zip': 'MG'}},
    {'label': 'Malaisie', 'value': {'name': 'Malaisie', 'zip': 'MY'}},
    {'label': 'Malawi', 'value': {'name': 'Malawi', 'zip': 'MW'}},
    {'label': 'Maldives', 'value': {'name': 'Maldives', 'zip': 'MV'}},
    {'label': 'Mali', 'value': {'name': 'Mali', 'zip': 'ML'}},
    {'label': 'Malte', 'value': {'name': 'Malte', 'zip': 'MT'}},
    {'label': 'Maroc', 'value': {'name': 'Maroc', 'zip': 'MA'}},
    {'label': 'Martinique', 'value': {'name': 'Martinique', 'zip': 'MQ'}},
    {'label': 'Maurice', 'value': {'name': 'Maurice', 'zip': 'MU'}},
    {'label': 'Mauritanie', 'value': {'name': 'Mauritanie', 'zip': 'MR'}},
    {'label': 'Mayotte', 'value': {'name': 'Mayotte', 'zip': 'YT'}},
    {'label': 'Mexique', 'value': {'name': 'Mexique', 'zip': 'MX'}},
    {'label': 'Moldavie', 'value': {'name': 'Moldavie', 'zip': 'MD'}},
    {'label': 'Monaco', 'value': {'name': 'Monaco', 'zip': 'MC'}},
    {'label': 'Mongolie', 'value': {'name': 'Mongolie', 'zip': 'MN'}},
    {'label': 'Monténégro', 'value': {'name': 'Monténégro', 'zip': 'ME'}},
    {'label': 'Montserrat', 'value': {'name': 'Montserrat', 'zip': 'MS'}},
    {'label': 'Mozambique', 'value': {'name': 'Mozambique', 'zip': 'MZ'}},
    {'label': 'Myanmar', 'value': {'name': 'Myanmar', 'zip': 'MM'}},
    {'label': 'Namibie', 'value': {'name': 'Namibie', 'zip': 'NA'}},
    {'label': 'Nauru', 'value': {'name': 'Nauru', 'zip': 'NR'}},
    {'label': 'Népal', 'value': {'name': 'Népal', 'zip': 'NP'}},
    {'label': 'Nicaragua', 'value': {'name': 'Nicaragua', 'zip': 'NI'}},
    {'label': 'Niger', 'value': {'name': 'Niger', 'zip': 'NE'}},
    {'label': 'Nigéria', 'value': {'name': 'Nigéria', 'zip': 'NG'}},
    {'label': 'Niue', 'value': {'name': 'Niue', 'zip': 'NU'}},
    {'label': 'Norvège', 'value': {'name': 'Norvège', 'zip': 'NO'}},
    {'label': 'Nouvelle-Calédonie',
     'value': {'name': 'Nouvelle-Calédonie', 'zip': 'NC'}},
    {'label': 'Nouvelle-Zélande',
     'value': {'name': 'Nouvelle-Zélande', 'zip': 'NZ'}},
    {'label': 'Oman', 'value': {'name': 'Oman', 'zip': 'OM'}},
    {'label': 'Ouganda', 'value': {'name': 'Ouganda', 'zip': 'UG'}},
    {'label': 'Ouzbékistan', 'value': {'name': 'Ouzbékistan', 'zip': 'UZ'}},
    {'label': 'Pakistan', 'value': {'name': 'Pakistan', 'zip': 'PK'}},
    {'label': 'Palaos', 'value': {'name': 'Palaos', 'zip': 'PW'}},
    {'label': 'Panama', 'value': {'name': 'Panama', 'zip': 'PA'}},
    {'label': 'Papouasie-Nouvelle-Guinée',
     'value': {'name': 'Papouasie-Nouvelle-Guinée', 'zip': 'PG'}},
    {'label': 'Paraguay', 'value': {'name': 'Paraguay', 'zip': 'PY'}},
    {'label': 'Pays-Bas', 'value': {'name': 'Pays-Bas', 'zip': 'NL'}},
    {'label': 'Pérou', 'value': {'name': 'Pérou', 'zip': 'PE'}},
    {'label': 'Philippines', 'value': {'name': 'Philippines', 'zip': 'PH'}},
    {'label': 'Pitcairn', 'value': {'name': 'Pitcairn', 'zip': 'PN'}},
    {'label': 'Pologne', 'value': {'name': 'Pologne', 'zip': 'PL'}},
    {'label': 'Polynésie française',
     'value': {'name': 'Polynésie française', 'zip': 'PF'}},
    {'label': 'Porto Rico', 'value': {'name': 'Porto Rico', 'zip': 'PR'}},
    {'label': 'Portugal', 'value': {'name': 'Portugal', 'zip': 'PT'}},
    {'label': 'Qatar', 'value': {'name': 'Qatar', 'zip': 'QA'}},
    {'label': 'R.A.S. chinoise de Hong Kong',
     'value': {'name': 'R.A.S. chinoise de Hong Kong', 'zip': 'HK'}},
    {'label': 'R.A.S. chinoise de Macao',
     'value': {'name': 'R.A.S. chinoise de Macao', 'zip': 'MO'}},
    {'label': 'régions éloignées de l’Océanie',
     'value': {'name': 'régions éloignées de l’Océanie', 'zip': 'QO'}},
    {'label': 'République centrafricaine',
     'value': {'name': 'République centrafricaine', 'zip': 'CF'}},
    {'label': 'République démocratique du Congo',
     'value': {'name': 'République démocratique du Congo', 'zip': 'CD'}},
    {'label': 'République dominicaine',
     'value': {'name': 'République dominicaine', 'zip': 'DO'}},
    {'label': 'République tchèque',
     'value': {'name': 'République tchèque', 'zip': 'CZ'}},
    {'label': 'Réunion', 'value': {'name': 'Réunion', 'zip': 'RE'}},
    {'label': 'Roumanie', 'value': {'name': 'Roumanie', 'zip': 'RO'}},
    {'label': 'Royaume-Uni', 'value': {'name': 'Royaume-Uni', 'zip': 'GB'}},
    {'label': 'Russie', 'value': {'name': 'Russie', 'zip': 'RU'}},
    {'label': 'Rwanda', 'value': {'name': 'Rwanda', 'zip': 'RW'}},
    {'label': 'Sahara occidental',
     'value': {'name': 'Sahara occidental', 'zip': 'EH'}},
    {'label': 'Saint-Barthélémy',
     'value': {'name': 'Saint-Barthélémy', 'zip': 'BL'}},
    {'label': 'Saint-Kitts-et-Nevis',
     'value': {'name': 'Saint-Kitts-et-Nevis', 'zip': 'KN'}},
    {'label': 'Saint-Marin', 'value': {'name': 'Saint-Marin', 'zip': 'SM'}},
    {'label': 'Saint-Martin', 'value': {'name': 'Saint-Martin', 'zip': 'MF'}},
    {'label': 'Saint-Pierre-et-Miquelon',
     'value': {'name': 'Saint-Pierre-et-Miquelon', 'zip': 'PM'}},
    {'label': 'Saint-Vincent-et-les Grenadines',
     'value': {'name': 'Saint-Vincent-et-les Grenadines', 'zip': 'VC'}},
    {'label': 'Sainte-Hélène', 'value': {'name': 'Sainte-Hélène', 'zip': 'SH'}},
    {'label': 'Sainte-Lucie', 'value': {'name': 'Sainte-Lucie', 'zip': 'LC'}},
    {'label': 'Samoa', 'value': {'name': 'Samoa', 'zip': 'WS'}},
    {'label': 'Samoa américaines',
     'value': {'name': 'Samoa américaines', 'zip': 'AS'}},
    {'label': 'Sao Tomé-et-Principe',
     'value': {'name': 'Sao Tomé-et-Principe', 'zip': 'ST'}},
    {'label': 'Sénégal', 'value': {'name': 'Sénégal', 'zip': 'SN'}},
    {'label': 'Serbie', 'value': {'name': 'Serbie', 'zip': 'RS'}},
    {'label': 'Serbie-et-Monténégro',
     'value': {'name': 'Serbie-et-Monténégro', 'zip': 'CS'}},
    {'label': 'Seychelles', 'value': {'name': 'Seychelles', 'zip': 'SC'}},
    {'label': 'Sierra Leone', 'value': {'name': 'Sierra Leone', 'zip': 'SL'}},
    {'label': 'Singapour', 'value': {'name': 'Singapour', 'zip': 'SG'}},
    {'label': 'Slovaquie', 'value': {'name': 'Slovaquie', 'zip': 'SK'}},
    {'label': 'Slovénie', 'value': {'name': 'Slovénie', 'zip': 'SI'}},
    {'label': 'Somalie', 'value': {'name': 'Somalie', 'zip': 'SO'}},
    {'label': 'Soudan', 'value': {'name': 'Soudan', 'zip': 'SD'}},
    {'label': 'Sri Lanka', 'value': {'name': 'Sri Lanka', 'zip': 'LK'}},
    {'label': 'Suède', 'value': {'name': 'Suède', 'zip': 'SE'}},
    {'label': 'Suisse', 'value': {'name': 'Suisse', 'zip': 'CH'}},
    {'label': 'Suriname', 'value': {'name': 'Suriname', 'zip': 'SR'}},
    {'label': 'Svalbard et Île Jan Mayen',
     'value': {'name': 'Svalbard et Île Jan Mayen', 'zip': 'SJ'}},
    {'label': 'Swaziland', 'value': {'name': 'Swaziland', 'zip': 'SZ'}},
    {'label': 'Syrie', 'value': {'name': 'Syrie', 'zip': 'SY'}},
    {'label': 'Tadjikistan', 'value': {'name': 'Tadjikistan', 'zip': 'TJ'}},
    {'label': 'Taïwan', 'value': {'name': 'Taïwan', 'zip': 'TW'}},
    {'label': 'Tanzanie', 'value': {'name': 'Tanzanie', 'zip': 'TZ'}},
    {'label': 'Tchad', 'value': {'name': 'Tchad', 'zip': 'TD'}},
    {'label': 'Terres australes françaises',
     'value': {'name': 'Terres australes françaises', 'zip': 'TF'}},
    {'label': "Territoire britannique de l'océan Indien",
     'value': {'name': "Territoire britannique de l'océan Indien", 'zip': 'IO'}},
    {'label': 'Territoire palestinien',
     'value': {'name': 'Territoire palestinien', 'zip': 'PS'}},
    {'label': 'Thaïlande', 'value': {'name': 'Thaïlande', 'zip': 'TH'}},
    {'label': 'Timor oriental', 'value': {'name': 'Timor oriental', 'zip': 'TL'}},
    {'label': 'Togo', 'value': {'name': 'Togo', 'zip': 'TG'}},
    {'label': 'Tokelau', 'value': {'name': 'Tokelau', 'zip': 'TK'}},
    {'label': 'Tonga', 'value': {'name': 'Tonga', 'zip': 'TO'}},
    {'label': 'Trinité-et-Tobago',
     'value': {'name': 'Trinité-et-Tobago', 'zip': 'TT'}},
    {'label': 'Tristan da Cunha',
     'value': {'name': 'Tristan da Cunha', 'zip': 'TA'}},
    {'label': 'Tunisie', 'value': {'name': 'Tunisie', 'zip': 'TN'}},
    {'label': 'Turkménistan', 'value': {'name': 'Turkménistan', 'zip': 'TM'}},
    {'label': 'Turquie', 'value': {'name': 'Turquie', 'zip': 'TR'}},
    {'label': 'Tuvalu', 'value': {'name': 'Tuvalu', 'zip': 'TV'}},
    {'label': 'Ukraine', 'value': {'name': 'Ukraine', 'zip': 'UA'}},
    {'label': 'Union européenne',
     'value': {'name': 'Union européenne', 'zip': 'EU'}},
    {'label': 'Uruguay', 'value': {'name': 'Uruguay', 'zip': 'UY'}},
    {'label': 'Vanuatu', 'value': {'name': 'Vanuatu', 'zip': 'VU'}},
    {'label': 'Venezuela', 'value': {'name': 'Venezuela', 'zip': 'VE'}},
    {'label': 'Viêt Nam', 'value': {'name': 'Viêt Nam', 'zip': 'VN'}},
    {'label': 'Wallis-et-Futuna',
     'value': {'name': 'Wallis-et-Futuna', 'zip': 'WF'}},
    {'label': 'Yémen', 'value': {'name': 'Yémen', 'zip': 'YE'}},
    {'label': 'Zambie', 'value': {'name': 'Zambie', 'zip': 'ZM'}},
    {'label': 'Zimbabwe', 'value': {'name': 'Zimbabwe', 'zip': 'ZW'}}]